/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useMemo } from 'react';
import { matchPath } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Selectors } from 'store/ducks/startUp';
import { ActionButton } from 'types/components/ActionButtonsGroup';
import { PrivateRoutePath, StartUpRoutePath } from 'routes/paths';
import translate from 'services/i18n/translate';
import MainSection from 'types/MainSection';
import { Hero } from 'ui/components';
import LandingPageBackground from 'assets/images/background/LandingPage_BackgroundImage.png';

function getActionButtons(): ActionButton[] {
  /**
   * TODO Dummy data that must be adapted when the store connection is implemented
   */
  const isSignupEnabled = false;

  const actionButtons: ActionButton[] = [
    {
      key: 'signIn',
      text: translate['menu.profile.signIn'],
      linkPath: StartUpRoutePath.SIGNIN,
    },
  ];

  if (isSignupEnabled) {
    actionButtons.push({
      key: 'signUp',
      text: translate['menu.profile.signUp'],
    });
  }

  return actionButtons;
}

const getUiArea = (fromPath?: string): MainSection => {
  if (fromPath) {
    let match = matchPath(fromPath, { path: PrivateRoutePath.MYTV });
    if (match) {
      return MainSection.MY_TV;
    }

    match = matchPath(fromPath, { path: PrivateRoutePath.ONDEMAND });
    if (match) {
      return MainSection.ONDEMAND;
    }
  }
  return MainSection.WATCH_TV;
};

export default function SignInSignUp(): JSX.Element {
  const from = useSelector(Selectors.fromLocation);
  const section = getUiArea(from);

  return useMemo(
    () => (
      <div className="home">
        <Hero
          toAuthenticate
          section={section}
          backgroundImage={LandingPageBackground}
          actionButtons={getActionButtons()}
        />
      </div>
    ),
    [section]
  );
}
